import React, { useEffect, useState } from 'react';
import useLocales from '../../hooks/useLocales';
import { CONDITION_STATUS, CONDITION_STATUS_JA, LANGUAGE } from '../../constants';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ConditionStatus } from '../../types/condition';

/**
 * conditionのステータスを表示するレンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const ConditionStatusRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const conditionStatus: ConditionStatus = params.value;
  const { currentLang } = useLocales();
  const [statusName, setStatusName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    const name: string | undefined = currentLang.value === LANGUAGE.JA ? CONDITION_STATUS_JA[conditionStatus] : CONDITION_STATUS[conditionStatus];
    setStatusName(name ?? '');
  }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <div className="condition-status-name">{statusName}</div>;
};

export default ConditionStatusRenderer;
